import React, { FunctionComponent } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { IWidgetKpiSortableRowParams } from './types';
import { WidgetKpiRow } from '../WidgetKpiRow';

const WidgetKpiSortableRow: FunctionComponent<IWidgetKpiSortableRowParams> = ({ kpiRowId, index }) => {
  return (
    <Droppable droppableId={kpiRowId} key={index} direction="vertical" type="column" isDropDisabled={true}>
      {(provided) => (
        <div {...provided.droppableProps} ref={provided.innerRef}>
          <Draggable key={`draggable-row-${kpiRowId}`} draggableId={kpiRowId} index={index} isDragDisabled={true}>
            {(provided) => <WidgetKpiRow key={kpiRowId} kpiRowId={kpiRowId} provided={provided} />}
          </Draggable>
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};
export default WidgetKpiSortableRow;
